import { Trans, useTranslation } from "react-i18next";
import Hyperlink from "@ingka/hyperlink";
import { getCredentialUrl } from "../utils";
import { config } from "../config";
import Message from "./Message";
import styled from "styled-components";
import {
  isSignedIn as isUserSignedIn,
  isFamilyMember as isUserFamilyMember,
  useAppContext,
} from "../contextProviders/AppContext";
import { BOOK_EVENT, EVENTS } from "../enums";

type AlertProps = {
  margin?: string;
  initiator: "EVENTS" | "BOOK_EVENT";
  freeForAll?: boolean;
};

const Wrapper = styled.div<{ margin: string | undefined }>`
  margin: ${({ margin }) => margin || ""};
`;

const LoginAlert = ({ margin, initiator, freeForAll }: AlertProps) => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const isSignedIn = useSelector(isUserSignedIn);
  const isFamilyMember = useSelector(isUserFamilyMember);
  const registerFamilyUrl = getCredentialUrl(config.joinIkeaFamily);
  const registerRegularUrl = getCredentialUrl(config.joinIkeaRegular);
  const loginUrl = getCredentialUrl(config.loginUrl);
  const upgradeUrl = getCredentialUrl(config.upgradeIkeaFamily);
  const registerUrl = freeForAll ? registerRegularUrl : registerFamilyUrl;

  if (isSignedIn && isFamilyMember) {
    return null;
  }

  if (initiator === EVENTS && isSignedIn && !isFamilyMember) {
    return null;
  }

  if (initiator === BOOK_EVENT && isSignedIn && freeForAll) {
    return null;
  }

  let message = "";
  if (initiator === EVENTS) {
    message = "alert.needToBeSignedInEvents";
  } else if (initiator === BOOK_EVENT) {
    if (isSignedIn && !freeForAll && !isFamilyMember) {
      message = "alert.needToUpgrade";
    } else if (!isSignedIn) {
      message = freeForAll
        ? "alert.needToBeSignedInEvent"
        : "alert.needToBeSignedInFamilyEvent";
    }
  }

  return (
    <Wrapper margin={margin}>
      <Message subtle role="alert" id="login-alert">
        <Trans
          i18nKey={message}
          components={{
            LoggedIn: <Hyperlink url={loginUrl} text={t("alert.loggedIn")} />,
            CreateAccount: (
              <Hyperlink url={registerUrl} text={t("alert.createAccount")} />
            ),
            UpgradeAccount: (
              <Hyperlink url={upgradeUrl} text={t("alert.upgrade")} />
            ),
          }}
        />
      </Message>
    </Wrapper>
  );
};

export default LoginAlert;
